/* eslint-disable @typescript-eslint/no-explicit-any */
import { Spin } from 'antd'
import guildApi from 'apis/guildApi'
import { constants } from 'apps'
import { CLOSE_BTN } from 'assets/images'
import { ChooseHorseItem } from 'features/Race/components'
import { useDebounce, useUpdateEffect } from 'hooks'
import { GUILD_MESSAGE, SPECIAL_MESSAGE } from 'i18n/constants'
import { defaultRegionFilters, HorseAvailable, MyHorseListParams } from 'models'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Modal, SearchInput } from 'shared'
import Button from 'shared/Button'
import { handleAsyncRequest } from 'utils/helper'
import ChooseHorseModalGuildFarmStyled from './styled'
import SelectCustom from 'shared/SelectCustom'
import { NUMBER, STRING_REGION } from 'apps/constants'

interface ChooseHorseModalGuildFarmProps {
  toggleIsModalOpen: (value?: boolean) => void
  onCloseButtonClick: () => void
  toggleIsModalSpecialRaceOpen: (value?: boolean) => void
  getHorseDetail: (value: HorseAvailable) => void
}

const myHorseListParams: MyHorseListParams = {
  limit: NUMBER.TEN,
  page: NUMBER.ONE
  // sort: 'horse_id-asc'
}

function ChooseHorseModalGuildFarm({
  toggleIsModalOpen,
  onCloseButtonClick,
  toggleIsModalSpecialRaceOpen,
  getHorseDetail,
}: ChooseHorseModalGuildFarmProps) {
  const horseListRef = useRef<HTMLDivElement>(null)
  const [horseList, setHorseList] = useState<HorseAvailable[]>([])
  const [searchValue, setSearchValue] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [params, setParams] = useState<MyHorseListParams>(myHorseListParams)
  const [total, setTotal] = useState(1)
  const debounceSearchValue = useDebounce<string>(searchValue, constants.DEBOUNCE_TIME)
  const [regionSelect, setRegionSelect] = useState('Region')

  const handleOnChange = (horse: HorseAvailable) => {
    getHorseDetail(horse)
    toggleIsModalSpecialRaceOpen(true)
  }

  const { t } = useTranslation()

  const fetchListRaces = async () => {
    setIsLoading(true)
    const [error, result] = await handleAsyncRequest(
      guildApi.getAvailableMyHorses({ ...params })
    )
    if (error) {
      setIsLoading(false)
      return
    }
    const records = result?.data.records
    if (records && records.length === NUMBER.ZERO) {
      // setLoader(true)
    }
    setTotal(result?.data.total)
    setHorseList([...horseList, ...records])
    setIsLoading(false)
  }

  useEffect(() => {
    fetchListRaces()
  }, [params])

  const handleSearchValueChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value)
  }

  useUpdateEffect(() => {
    setHorseList([])
    setParams({ ...params, page: NUMBER.ONE, horseName: debounceSearchValue })
  }, [debounceSearchValue])

  const fetchMoreRaces = () => {
    setParams({ ...params, page: params.page + NUMBER.ONE })
  }

  const checkNoHorse = () => (total === NUMBER.ZERO && debounceSearchValue.length === NUMBER.ZERO && !isLoading)

  const layoutBodySpecialHorseModal = () => {
    if (checkNoHorse()) {
      return layoutNoHorse()
    } else return layoutHorseList()
  }

  const handleRegionFilterClicked = (item: string) => {
    setHorseList([])
    if (item?.toUpperCase() === STRING_REGION.SEOUL || item?.toUpperCase() === STRING_REGION.TOKYO) {
      setParams({ ...params, page: NUMBER.ONE, region: item?.toUpperCase() })
    } else {
      setParams({ ...params, page: NUMBER.ONE, region: '' })
    }
    setRegionSelect(item)
  }

  const layoutHorseList = () => {
    return (
      <>
        <div className='search-horse-container d-flex align-items-center justify-content-between'>
          <div className='search-title color-white'> Total: {!isLoading && total} </div>
          <div className='search__box'>
            <SearchInput
              onAutoFocus={true}
              searchValue={searchValue}
              handleSearchValueChanged={handleSearchValueChanged}
              customClass='search-input'
            />

            {/* region */}
            <SelectCustom
              dataSelect={defaultRegionFilters}
              nameSelect={regionSelect}
              onSelected={handleRegionFilterClicked}
              customClass='select-custom'
            />
          </div>
        </div>

        {total === 0 && debounceSearchValue.length != 0 && !isLoading ?
          <div
            className='no-horse pt-5'
            dangerouslySetInnerHTML={{
              __html: t(`${SPECIAL_MESSAGE}.noHorseSearch`, { search: searchValue })
            }}
          /> :
          <InfiniteScroll
            dataLength={horseList.length}
            next={fetchMoreRaces}
            hasMore={true}
            loader={isLoading ? <Spin className='mt-2 mr-3 d-flex justify-content-center pt-5' /> : ''}
            height={500}
          >
            {horseList.length > 0 && (
              <div className='horse-list-container d-flex flex-column' ref={horseListRef}>
                {horseList.map((horse, index: number) => (
                  <div key={index} className='horse-item'>
                    <>
                      <ChooseHorseItem horse={horse} onHorseClick={() => handleOnChange(horse)} />
                    </>
                  </div>
                ))}
              </div>
            )}
          </InfiniteScroll>}
      </>
    )
  }

  const layoutNoHorse = () => {
    return <>
      <div className='no-horse-title'>THERE IS NO HORSE AVAILABLE</div>
      <div className='btn-container'>
        <Button buttonName='Close' onClickButton={onCloseButtonClick} width={150} type="btnCancel" />
      </div>
    </>
  }

  return (
    <Modal onOverlayClick={toggleIsModalOpen}>
      <ChooseHorseModalGuildFarmStyled>
        <div className='choose-horse-modal'>
          <button className='close-btn p-0 position-absolute' role='button' onClick={onCloseButtonClick}>
            <img src={CLOSE_BTN} alt='close' />
          </button>
          <div className={`race-info-container color-primary ${checkNoHorse() ? '' : 'line'}`}>
            {t(`${GUILD_MESSAGE}.registerHorse`)}
          </div>
          {layoutBodySpecialHorseModal()}
          {/* {layoutNoHorse()} */}
        </div>
      </ChooseHorseModalGuildFarmStyled>
    </Modal>
  )
}

export default ChooseHorseModalGuildFarm
